var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-container"},[_c('ContentBox',{attrs:{"title":"Produtos","isLarge":true}},[_c('CartBox')],1),_c('ContentBox',{attrs:{"title":"Cupom"}},[_c('CouponContent')],1),_c('ContentBox',{attrs:{"title":"Frete"}},[_c('FreightContent')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }